
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useSopTasks = (brandId: string) => {
  return useQuery({
    queryKey: ['sop-tasks', brandId],
    queryFn: async () => {
      if (!brandId) return [];
      
      const { data, error } = await supabase
        .from('sop_tasks')
        .select('*')
        .eq('brand_id', brandId);

      if (error) {
        console.error('Error fetching SOP tasks:', error);
        throw error;
      }

      return data || [];
    },
    enabled: !!brandId,
  });
};
